import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Phonecall = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21 28H11C7.138 28 4 24.863 4 21V19C4 17.35 5.35 16 7 16H11C12.65 16 14 17.35 14 19V20H18V19C18 17.35 19.35 16 21 16H25C26.65 16 28 17.35 28 19V21C28 24.863 24.863 28 21 28ZM7 18C6.45 18 6 18.45 6 19V21C6 23.762 8.238 26 11 26H21C23.762 26 26 23.762 26 21V19C26 18.45 25.55 18 25 18H21C20.45 18 20 18.45 20 19V21C20 21.55 19.55 22 19 22H13C12.45 22 12 21.55 12 21V19C12 18.45 11.55 18 11 18H7Z" />
		<path d="M25.8 8.412C25.8 8.412 22.5 4 16 4C9.5 4 6.2 8.4 6.2 8.412C6.075 8.574 6 8.787 6 9C6 9.55 6.45 10 7 10C7.325 10 7.612 9.85 7.787 9.613C7.787 9.613 10.499 6.001 16 6.001C21.501 6.001 24.2 9.601 24.2 9.601C24.388 9.839 24.675 10.001 25 10.001C25.55 10.001 26 9.551 26 9.001C26 8.776 25.925 8.576 25.8 8.413V8.412Z" />
		<path d="M21.712 12.287C21.712 12.287 19.5 10 15.999 10C12.498 10 10.286 12.287 10.286 12.287C10.111 12.462 9.99902 12.712 9.99902 13C9.99902 13.55 10.449 14 10.999 14C11.274 14 11.524 13.887 11.699 13.713C11.699 13.713 13.499 12 15.999 12C18.499 12 20.286 13.713 20.286 13.713C20.461 13.888 20.711 14 20.998 14C21.548 14 21.998 13.55 21.998 13C21.998 12.725 21.885 12.475 21.71 12.287H21.712Z" />
	</svg>
);

export default Phonecall;
